'use client';
import { useState } from 'react';
import { useRouter } from 'next/navigation';

export default function Login() {
  const router = useRouter();
  const [formData, setFormData] = useState({
    url: 'https://',
    username: '',
    accessKey: ''
  });
  const [status, setStatus] = useState('');

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setStatus('Connecting to Vtiger...');

    try {
      const res = await fetch('/api/vtiger-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      
      const data = await res.json();

      if (data.success) {
        setStatus('✅ Success! Redirecting...');
        // Save ID to LocalStorage to "remember" the user
        localStorage.setItem('clientId', data.clientId);
        // Redirect to Dashboard
        router.push('/dashboard'); 
      } else {
        setStatus('❌ Error: ' + data.error);
      }
    } catch (err) {
      setStatus('❌ Network Error');
    }
  };

  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-slate-900 text-white p-4">
      <div className="bg-slate-800 p-8 rounded-lg shadow-xl w-full max-w-md">
        <h1 className="text-3xl font-bold mb-6 text-center">Whatsapp-Crm Connector</h1>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-400 mb-1">Vtiger URL</label>
            <input 
              type="text" 
              className="w-full p-3 rounded bg-slate-700 border border-slate-600 focus:border-green-500 outline-none transition"
              placeholder="https://crm.yourcompany.com"
              value={formData.url}
              onChange={(e) => setFormData({...formData, url: e.target.value})}
              required
            />
          </div>
          
          <div>
            <label className="block text-sm text-gray-400 mb-1">Username</label>
            <input 
              type="text" 
              className="w-full p-3 rounded bg-slate-700 border border-slate-600 focus:border-green-500 outline-none transition"
              placeholder="admin"
              value={formData.username}
              onChange={(e) => setFormData({...formData, username: e.target.value})}
              required
            />
          </div>

          <div>
            <label className="block text-sm text-gray-400 mb-1">Access Key (Not Password)</label>
            <input 
              type="password" 
              className="w-full p-3 rounded bg-slate-700 border border-slate-600 focus:border-green-500 outline-none transition"
              placeholder="Your Access Key (My Preferences)"
              value={formData.accessKey}
              onChange={(e) => setFormData({...formData, accessKey: e.target.value})}
              required
            />
            <p className="text-xs text-gray-500 mt-1">Find this in My Preferences {'>'} Access Key</p>
          </div>

          <button 
            type="submit"
            className="w-full bg-green-600 hover:bg-green-500 text-white font-bold py-3 rounded transition"
          >
            Login to Dashboard
          </button>
        </form>

        <p className="text-center mt-4 text-yellow-400 font-mono text-sm">{status}</p>
      </div>
    </main>
  );
}